import React, { PureComponent, Fragment } from 'react'
import { isObservableArray } from 'mobx'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import Select from '@Form/Select'
import Input from '@Form/Input'
import Checkbox from '@Form/Checkbox'
import Button from '@UniformComponents/Button'
import { getOptionTitle } from "../../../utils/QuestionHelper"
import Weight from './Weight'

import QuestionWeight from './model/QuestionWeight'
import NumericOption from './model/NumericOption'

@observer
class Variable extends PureComponent {
    variableTypes = [
        {
            value: 'numeric',
            label: 'Numeric',
            filter: (question) => (
                ['NF'].includes(question.questionTypeCode)
                || (
                    R.pathOr(false, ['optionSet', 'hasNumericCodes'], question)
                )
                || (
                    R.pathOr(false, ['optionSetX', 'hasNumericCodes'], question)
                )
                || (
                    R.pathOr([], ['optionSetX', 'options'], question).some(({ fieldType }) => fieldType === 'I')
                )
            ),
        },
        {
            value: 'answers',
            label: 'Answers',
            filter: (question) => (
                ['CH'].includes(question.questionTypeCode)
            ),
        },
        {
            value: 'percentage',
            label: 'Percentage',
            filter: (question) => (
                ['RD', 'CH', 'PC'].includes(question.questionTypeCode)
            ),
        },
        {
            value: 'kpi',
            label: 'KPI',
            filter: (question) => (
                ['RD', 'SG'].includes(question.questionTypeCode)
            ),
        },
        {
            value: 'sum',
            label: 'Sum',
            filter: (question) => (
                ['SG', 'TB', 'NF', 'I'].includes(question.questionTypeCode)
            ),
        },
        {
            value: 'average',
            label: 'Average',
            filter: (question) => (
                ['SG', 'TB', 'NF', 'I'].includes(question.questionTypeCode)
            ),
        },
        {
            value: 'optionToNumeric',
            label: 'Option to Numeric',
            filter: (question) => (
                ['RD'].includes(question.questionTypeCode)
            ),
        },
        {
            value: 'random',
            label: 'Random',
            filter: () => true,
        },
    ]

    constructor(props) {
        super(props)

        const { variable, questions } = props
        let questionType
        if (variable.questionId) {
            const question = questions
                .find(({ question }) => R.pathOr('', ['id'], question).toUpperCase() === variable.questionId)
            this.question = R.pathOr({}, ['question'], question)
            questionType = R.pathOr('', ['question', 'questionTypeCode'], question)
        }

        this.state = {
            showWeight: Boolean(variable.weight),
            model: {
                name: '',
                variableType: '',
                questionId: null,
                optionId: null,
                weight: null,
            },
            questionType,
        }

        props.register(this.getValue)
    }

    getTypes = () => (
        this.variableTypes
    )

    registerWeight = (f) => {
        this.getWeight = f
    }

    getValue = () => ({
        name: this.state.model.name,
        value: this.state.model.value * this.getWeight(),
    })

    changeVariable = (field) => {
        const {
            name,
            value,
            question,
            formId,
        } = field
        const { variable } = this.props

        if (question) {
            const { questionTypeCode } = question
            this.question = question
            this.setState({
                questionType: questionTypeCode,
            })

            if (questionTypeCode === 'I') {
                variable.optionId = undefined
            }
            variable.formId = formId
        }
        if (['questionId', 'variableType'].includes(name)) {
            variable.rowId = undefined
        }

        variable[name] = Array.isArray(value)
            ? value.map((v) => (
                typeof v === 'object'
                    ? v.value
                    : v
            )) : value
    }

    toggleWeight = ({ value }) => {
        const { variable } = this.props
        if (value) {
            variable.weight = new QuestionWeight({
                kind: 'question',
            })
        } else {
            variable.weight = undefined
        }
        this.setState({
            showWeight: value,
        })
    }

    getOptions = () => {
        const { questions, variable } = this.props
        const { questionId } = variable

        const question = questions.find(({ value }) => value === questionId)

        console.log('getOptions', questionId, question)

        if (!question) return []

        let options = []

        const { questionTypeCode } = question.question

        if (['NF', 'FM'].includes(question.question.questionTypeCode)) {
            options = question.question.optionSet.map(({ question }) => ({
                id: question.id,
                langs: question.content.shortTitle,
            }))
        } else if (questionTypeCode === 'TB') {
            options = question.question.optionSetX.options.filter(({ fieldType }) => fieldType === 'I')
        } else if (question.question.optionSet) {
            options = question.question.optionSet.options
        } else if (question.question.optionSetY) {
            options = question.question.optionSetY.options
        }

        return options.map(({ id, langs }) => {
            console.log('optionLabel', id, langs, getOptionTitle(langs, 'en_GB', 'en_GB', question.question.metadata.initialLocale))
            return ({
                value: id.toUpperCase(),
                label: langs.en_GB.text,
            })
        })
    }

    getRowOptions = () => {
        const { questions, variable } = this.props
        const { questionId } = variable

        const question = questions.find(({ value }) => value === questionId)

        if (!question) return []

        const { questionTypeCode } = question.question

        if (questionTypeCode !== 'TB') return []

        return question.question.optionSetY.options.map((option) => ({
            value: option.id.toUpperCase(),
            label: option.langs.en_GB.text,
        }))
    }

    getSet2Options = () => {
        const { questions, variable } = this.props
        const { questionId } = variable

        const question = questions.find(({ value }) => value === questionId)

        if (!question) return []

        const { questionTypeCode } = question.question

        if (questionTypeCode !== 'TB') return []

        console.log('getSet2Options', questionId, question.question.optionSetX.options)
        return question.question.optionSetX.options.map((option) => ({
            value: option.id.toUpperCase(),
            label: option.langs.en_GB.text,
        }))
    }

    addNumericOption = () => {
        const { variable } = this.props
        variable.numericOptions.push(new NumericOption({}))
    }

    chageOptionId = ({ value }, index) => {
        const { variable } = this.props
        variable.numericOptions[index].optionId = value
    }

    chageNumericValue = ({ value }, index) => {
        const { variable } = this.props
        variable.numericOptions[index].numericValue = (!R.isNil(value) && !R.isEmpty(value))
            ? Number(value)
            : value
    }

    removeNumericOption = (index) => {
        const { variable } = this.props
        variable.numericOptions.splice(index, 1)
    }

    renderNumercOptions = () => {
        const { variable } = this.props
        const { numericOptions } = variable

        const options = this.getOptions()

        return (
            <div
                style={{
                    border: '1px solid #777',
                    borderRadius: '8px',
                    padding: '10px',
                    marginTop: '10px',
                }}
            >
                <div>
                    Numeric options
                </div>
                {numericOptions.map((option, index) => {
                    const {
                        id,
                        optionId,
                        numericValue,
                        isDefault,
                    } = option
                    return (
                        <div
                            key={id}
                            style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                            }}
                        >
                            {isDefault
                                ? <span style={{ flex: 1 }}>Default</span>
                                : (
                                    <Select
                                        options={options}
                                        defaultValue={optionId}
                                        onBlur={(field) => this.chageOptionId(field, index)}
                                        name="optionId"
                                    />
                                )}
                            <Input
                                name="value"
                                onBlur={(field) => this.chageNumericValue(field, index)}
                                defaultValue={numericValue}
                                placeholder="Please enter a Numeric"
                            />
                            <i
                                onClick={() => this.removeNumericOption(index)}
                                className="fal fa-trash-alt fa-2x"
                                style={{
                                    cursor: 'pointer',
                                }}
                            />
                        </div>
                    )
                })}
                <div>
                    <Button
                        label="Add option"
                        onClick={this.addNumericOption}
                        cssClass="regular secondary"
                    />
                </div>
            </div>
        )
    }

    render() {
        const { questions, testFormula, variable, onDelete } = this.props
        const { showWeight, questionType } = this.state
        const {
            name,
            questionId,
            variableType,
            optionId,
            rowId,
        } = variable

        return (
            <div
                style={{
                    padding: '10px',
                    border: '1px solid #CCC',
                    borderRadius: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                }}
            >
                <Input
                    name="name"
                    label="Name"
                    onBlur={(field) => this.changeVariable(field)}
                    defaultValue={name}
                    placeholder="Please enter a name"
                />
                <Select
                    options={this.getTypes()}
                    label="Type"
                    defaultValue={variableType}
                    onBlur={(field) => this.changeVariable(field)}
                    name="variableType"
                />
                {variableType !== 'random' && (
                    <Fragment>
                        <Select
                            label="Question"
                            options={questions}
                            defaultValue={questionId}
                            onBlur={(field) => this.changeVariable(field)}
                            name="questionId"
                        />
                    </Fragment>
                )}
                {questionId && (
                    <Fragment>
                        {variableType === 'optionToNumeric' && (
                            this.renderNumercOptions()
                        )}
                        {(
                            ['percentage', 'numeric'].includes(variableType)
                            && !['NF', 'FM', 'I'].includes(questionType)
                         ) && (
                            <Fragment>
                                <Select
                                    key={variableType}
                                    label="Option"
                                    isMulti={(variableType === 'percentage')}
                                    blurOnClear={(variableType === 'percentage')}
                                    options={this.getOptions()}
                                    defaultValue={isObservableArray(optionId) ? optionId.slice() : optionId}
                                    onBlur={(field, action) => this.changeVariable(field, action)}
                                    name="optionId"
                                />
                            </Fragment>
                        )}
                        {(['numeric', 'average'].includes(variableType) && questionType === 'TB') && (
                            <Fragment>
                                <Select
                                    label="Row"
                                    options={this.getRowOptions()}
                                    defaultValue={rowId}
                                    onBlur={(field) => this.changeVariable(field)}
                                    isClearable
                                    name="rowId"
                                />
                            </Fragment>
                        )}
                        {['answers'].includes(variableType) && (
                            <Fragment>
                                <Select
                                    label="Option"
                                    options={this.getSet2Options()}
                                    defaultValue={optionId}
                                    onBlur={(field) => this.changeVariable(field)}
                                    isClearable
                                    name="optionId"
                                />
                            </Fragment>
                        )}
                        {['numeric'].includes(variableType) && ['NF', 'FM'].includes(questionType) && (
                            <Fragment>
                                <Select
                                    label="Option"
                                    options={this.getOptions()}
                                    defaultValue={optionId}
                                    onBlur={(field) => this.changeVariable(field)}
                                    name="optionId"
                                />
                            </Fragment>
                        )}
                    </Fragment>
                )}
                {variableType !== 'random' && (
                    <div>
                        <Checkbox
                            name={`${variable.id}_weight`}
                            defaultChecked={showWeight}
                            label="Toggle Weight"
                            onBlur={this.toggleWeight}
                            className="exploriNativeCheckbox"
                        />
                    </div>
                )}
                {showWeight && (
                    <Weight
                        variable={variable}
                        register={this.registerWeight}
                        questions={questions}
                        testFormula={testFormula}
                    />
                )}
                <div
                    style={{
                        justifyContent: 'end',
                        display: 'flex',
                    }}
                >
                    <Button
                        label="Delete variable"
                        cssClass="regular error"
                        icon="fal fa-trash-alt"
                        onClick={onDelete}
                    />
                </div>
            </div>
        )
    }
}

export default Variable
